
const initialState = { client: null, eventHandlers: {}, balancer: null };

export const photonApi = { ...initialState };

export const resetClient = () => {
  photonApi.client = initialState.client;
  photonApi.eventHandlers = initialState.eventHandlers;
  photonApi.balancer = initialState.balancer;
};
